/* eslint-disable */
// @ts-nocheck
import { Quill } from 'react-quill';
import ImageResize from 'quill-image-resize-module-react';

const Parchment = Quill.import('parchment');

Quill.register('modules/imageResize', ImageResize);
const insertNewline = function (quill, range, context, formattingChanges) {
    // Based on modules/keyboard.js handleEnter
    if (range.length > 0) {
        quill.scroll.deleteAt(range.index, range.length); // So we do not trigger text-change
    }
    let lineFormats = Object.keys(context.format).reduce(function (
        lineFormats,
        format
    ) {
        if (
            Parchment.query(format, Parchment.Scope.BLOCK) &&
            !Array.isArray(context.format[format])
        ) {
            lineFormats[format] = context.format[format];
        }
        return lineFormats;
    },
    {});
    quill.insertText(range.index, '\n', lineFormats, Quill.sources.USER);
    // Earlier scroll.deleteAt might have messed up our selection,
    // so insertText's built in selection preservation is not reliable
    quill.setSelection(range.index + 1, Quill.sources.SILENT);
    quill.focus();
    Object.keys(context.format).forEach((name) => {
        if (lineFormats[name] != null) return;
        if (Array.isArray(context.format[name])) return;
        if (name === 'link') return;
        quill.format(name, context.format[name], Quill.sources.USER);
    });
    quill.formatLine(range.index + 1, 1, formattingChanges, Quill.sources.USER);
};

const ENTER_KEY = 13;

export const bindings = {
    'header shift enter': {
        key: ENTER_KEY,
        shiftKey: true,
        collapsed: true,
        format: ['header'],
        suffix: /^$/,
        handler: function (range, context) {
            insertNewline(this.quill, range, context, { header: false, pspacing: '0px' });
            return false;
        },
    },
    'header enter': {
        key: ENTER_KEY,
        shiftKey: false,
        collapsed: true,
        format: ['header'],
        suffix: /^$/,
        handler: function (range, context) {
            insertNewline(this.quill, range, context, { header: false, pspacing: false });
            return false;
        },
    },
    'shift enter': {
        key: ENTER_KEY,
        shiftKey: true,
        handler: function (range, context) {
            insertNewline(this.quill, range, context, { pspacing: '0px' });
            return false;
        },
    },
    enter: {
        key: ENTER_KEY,
        shiftKey: false,
        handler: function (range, context) {
            insertNewline(this.quill, range, context, { pspacing: false });
            return false;
        },
    },
};

// This could be implemented via Parchment.Attributor.Class as well with a few modifications.
const pspacing = new Parchment.Attributor.Style('pspacing', 'padding-top');
Quill.register(pspacing, true);

const icon = new Parchment.Attributor.Attribute('icon', 'icon', {
    scope: Parchment.Scope.BLOCK,
});
Quill.register(icon);
